import styled from 'styled-components'
import { Grid } from '@material-ui/core'
import { theme } from '../../../../theme/Global/index'

export const Text = styled.span`
  &&& {
    > span {
      font-size: 18px;
      font-weight: 600;
      text-transform: uppercase;
      display: block;
    }
    font-size: 15px;
    font-weight: 600;
    color: ${theme.colors.text};
    text-align: left;
    display: block;
  }
`

export const GridTextContainer = styled(Grid)`
  &&& {
    display: flex;
    justify-content: ${props => props.align};
  }
`

export const UpdateText = styled.p`
  &&& {
    > span {
      display: block;
    }
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    max-height: 200px;
    overflow-y: auto;
    padding: 1rem 3rem 0 3rem;
  }
`

export const ProductsList = styled.ul`
  list-style: none;
  padding-inline-start: 0;
  margin-top: 0;
`

